<div class="favorites-page">
    <div class="page-wrapper">
        <p class="mb-2 text-center container title-favorites">Mis favoritos</p>
    </div>

    <div class="container loading-height">
        <app-events-fav [last]="false"></app-events-fav>
    </div>
</div>